module.exports = __webpack_public_path__ + "static/media/week-measurements-100.d81c8b7a.svg";